// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';

const lightbox = GLightbox();

const gallerylightbox = GLightbox({
    selector: ".glight-gallery"
});



$(document).ready(function(){
    $('.open--gallery').click(function() {
        gallerylightbox.open();
    })
})
